import React, { useState, useEffect } from 'react';
import FormComponent from '../../../Reusable_Components/FormComponent';
import axios from 'axios';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/Config/apiConfig';
import { useParams } from 'react-router-dom';

const OpportunitySourceInput = () => {
  const { sourceId = '' } = useParams();
  const decodedId = sourceId ? atob(sourceId) : sourceId;
  const id = decodedId.replace(/\D/g, '');
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const route = 'opportunitySource';

  useEffect(() => {
    if (sourceId) { setIsEditing(true); fetchDetails(); }
  }, [sourceId]);

  const fetchDetails = async () => {
    try {
      const response = await axios.get(API_DOMAIN + API_ROUTES['opportunitySource'] + id + '/', { headers });
      setFormData(response.data?.data ?? response.data);
    } catch (error) { console.error('Error fetching Opportunity Source details:', error); }
  };

  const fields = [{"name":"name","label":"Name","type":"text"},{"name":"description","label":"Description","type":"textarea"}];

  return (
    <div>
      <h1>{isEditing ? 'Edit Opportunity Source' : 'Create Opportunity Source'}</h1>
      <FormComponent fields={fields} initialFormData={formData} route={route} />
    </div>
  );
};

export default OpportunitySourceInput;